import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

import { useGame } from './use-game'

export const useGlobalData = (gameId, playerId) => {

  const dispatch = useDispatch()
  const { player } = useGame(gameId)

  // const game = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}) )
  // const global = game?.global


  const getGlobalData = (from, to, kpis, detail) =>
    dispatch(actions.getGlobalData(gameId, (playerId || player.playerId), {from, to, kpis, detail}))

  const saveGlobalData = (values, replace) => 
    dispatch(actions.saveGlobalData(gameId, (playerId || player.playerId), values, replace))

  return {
    getGlobalData,
    saveGlobalData,
    global
  }
}
